import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check\">\r\n<path d=\"M7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0ZM7 1.35484C10.1199 1.35484 12.6452 3.87967 12.6452 7C12.6452 10.1199 10.1203 12.6452 7 12.6452C3.88015 12.6452 1.35484 10.1203 1.35484 7C1.35484 3.88015 3.87967 1.35484 7 1.35484ZM10.9574 5.03173L10.3213 4.3905C10.1895 4.25769 9.97508 4.25682 9.84228 4.38858L5.85251 8.34629L4.16483 6.64492C4.0331 6.51212 3.81864 6.51124 3.68584 6.64297L3.04458 7.27907C2.91177 7.4108 2.9109 7.62526 3.04266 7.75809L5.60502 10.3412C5.73675 10.474 5.95121 10.4749 6.08402 10.3431L10.9555 5.51075C11.0883 5.37899 11.0891 5.16453 10.9574 5.03173Z\" fill=\"#0065F3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/check.svg
// module id = 7ZS0
// module chunks = 19